// extracted by mini-css-extract-plugin
export var anchor = "bj_fl";
export var anchors = "bj_fk";
export var document = "bj_fp";
export var documents = "bj_fn";
export var heading = "bj_G";
export var privacy = "bj_fm";
export var section = "bj_d";
export var tariff = "bj_fr";
export var tariffs = "bj_fq";